import { FormlyFieldConfig } from '@ngx-formly/core';

import { ISnSelectTemplateOptions } from './select-template-options.interface';

export interface ISnSelectFormFieldConfig extends FormlyFieldConfig {
  type: 'select';
  templateOptions?: ISnSelectTemplateOptions;
}
